import { Component } from 'react';

const addDefaultValueToFields = (fields, defaultProps) => fields.map((field) => {
    if (typeof field.fields !== 'undefined') {
        return {
            ...field,
            fields: addDefaultValueToFields(field.fields, defaultProps),
        };
    } else if (
        typeof field.defaultValue !== 'undefined' ||
        typeof defaultProps[field.name] === 'undefined' ||
        defaultProps[field.name] === null
    ) {
        return field;
    }
    return {
        ...field,
        defaultValue: defaultProps[field.name],
    };
});

class BlockComponent extends Component {
    static getBlockDefinition() {
        return this.blockDefinition;
    }

    static getBlockName() {
        const definition = this.getBlockDefinition();
        return definition.name || null;
    }

    static getBlockDescription() {
        const definition = this.getBlockDefinition();
        return definition.description || null;
    }

    static getBlockFields() {
        const definition = this.getBlockDefinition();
        const fields = definition.fields || [];
        const defaultProps = this.defaultProps;
        return addDefaultValueToFields(fields, defaultProps);
    }
}

export default BlockComponent;



// WEBPACK FOOTER //
// ./components/blocks/BlockComponent.jsx